module.exports = __webpack_public_path__ + "static/mobby-candidato-banner-mobile-c563999b5ecd8a92a098ec0db72e68e2.png";